module.exports = __webpack_public_path__ + "static/media/progress-book-read.d0be8bcd.svg";